<template>
  <div class="text-xs-center">
    <div class="centerx">
      <vs-button @click="activePrompt=true" color="primary" type="gradient">Notifier BTC</vs-button>
    </div>
    <vs-prompt
      @cancel="close"
      title="Notify BTC"
      @accept="acceptAlert"
      @close="close"
      accept-text="confirm"
      :is-valid="validHash"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        <vs-input
          :success="validHash"
          success-text="valid hash"
          :danger="errorHash"
          danger-text="invalid hash"
          label-placeholder="Enter hash"
          v-model="hash"
        />
      </div>
      <div class="centerx">
        <vs-alert :active="errorHash" color="danger" icon="new_releases">
          <span>
            Hash id is <b>not valid</b> try again
          </span>
        </vs-alert>
      </div>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      active1: true,
      activePrompt: false,
      numero: "",
      hash:"",
      fired:false
    };
  },
  computed: {
    validHash() {
      return /^[a-fA-F0-9]{64}$/.test(this.hash);
    },
    errorHash(){
      return this.hash.length> 0&&this.validHash==false
    }
  },
  methods: {



    acceptAlert(color) {

      if(this.fired){
        window.location.reload()
        return
      }
      this.fired =true

      if (this.validHash) {
        var url = `https://blockchain.info/rawtx/${this.hash}`;
      this.$vs.loading()
        axios
          .get(
            "https://us-central1-hiropay-6c8a4.cloudfunctions.net/app/hash",
            {
              params: {
                url: url
              }
            }
          )
          .then(async res => {

            if (this.$store.getters['deposit/btcObj']!==undefined) {
              if (res.data.message) {
              this.$vs.loading.close()
                    this.$vs.notify({
                     time:6000,
                    color: "danger",
                    title: "hash non correct",
                    text: "ce hash n'existe pas dans le réseau BITCOIN "
                  });
              
              }else{
            var response=res.data
            var hash=response.hash
            var getOuts=response.out;
            var countOuts=getOuts.length;
            

            //let block_index = response.block_index
            //let block_height =response.block_height

            let confirmed
            let error
            let double_spend
            let preference
            let confirmations



            await axios.get(`https://api.blockcypher.com/v1/btc/main/txs/${hash}`).then( ({data}) =>{
              console.log(data);
              double_spend =data.double_spend
              preference = data.preference
              confirmations =data.confirmations
              //console.log(double_spend, preference, confirmations);
            }).catch(async err=>{
              console.log(err);
              error = true
            })

            if (double_spend) {
              this.$vs.loading.close()
              this.$vs.notify({
                  time:6000,
                  color: "danger",
                  title: "Double depense",
                  text: "Votre transaction est invalide, double depense detecté"
                })
                return
            }

            if (error) {
              this.$vs.loading.close()
                this.$vs.notify({
                    time:10000,
                    color: "danger",
                    title: "Transacton non confirmée",
                    text: "veuillez soumettre votre Hash une fois votre transaction confirmée"
                  })
                  return
            }

            if (preference !== 'high' && confirmations < 1) {
              this.$vs.loading.close()
                this.$vs.notify({
                    time:10000,
                    color: "danger",
                    title: "Transacton non confirmée",
                    text: "veuillez soumettre votre Hash une fois votre transaction confirmée"
                  })
                  return
            }

             let btcAdr = this.$store.getters['deposit/btcAddress']
             let btcAdr0 = this.$store.getters['deposit/btcAddress0']
             
               var addMatch=[]
              for ( let i = 0; i < countOuts; i++) {
                var outAdd=response.out[i].addr;
                if (outAdd==btcAdr || outAdd == btcAdr0 ) {
                  addMatch.push(response.out[i])
                   var amount=response.out[i].value;
                   var calAmount=amount / 100000000
                }
              }


              Promise.all(addMatch).then(()=>{
                if (addMatch.length==1) {
                  this.$store
                    .dispatch("deposit/depotBtc", {
                      type: "btc",
                      amount: Number(calAmount),
                      hash: hash
                    }).then(()=>{
                      setTimeout(() => {
                         this.$vs.loading.close()
                         this.hash = ''
                      }, 750);
                    })
                }else{
                  this.$vs.loading.close()
                    this.$vs.notify({
                     time:6000,
                    color: "warning",
                    title: "Pas de transaction",
                    text: "Ce hash ne contient aucune transaction avec votre adresse"
                  });
                }
              });

            }

          }else{
              this.$vs.loading.close()
              this.$vs.notify({
                  time:6000,
                  color: "danger",
                  title: "Vous n'avez pas d'adresse",
                  text: "veillez générer une adresse BITCOIN"
                });
            }
            
          });
      } else {
        this.errorHash = true;
      }
    },

    close() {
      this.hash = "";
      this.$vs.notify({
        color: "warning",
        title: "Closed",
        text: "You close the notification prompt!"
      });
    }
    ,
  }
};
</script>

<style scoped>
.con-exemple-prompt {
  padding: 10px;
  padding-bottom: 10px;
}

.vs-input {
  width: 100%;
  margin-top: 10px;
}
</style>
